import { isWaiverQuestion } from '../../../models/survey';
import { CheckoutState } from '../../../state';
import { isRequiredQuestion } from '../../../utils/surveys';
import { getQuestionsCollection } from '../pureSelectors';
import { getQuestionsForAttendees } from './getQuestionsForAttendees';
import { getQuestionsForBuyer } from './getQuestionsForBuyer';

/**
 * @private Do not use this directly, derive information from `getSurvey` instead
 */
export const getHasWaiverQuestions = (state: CheckoutState) =>
    Object.values(getQuestionsCollection(state)).some((question) =>
        isWaiverQuestion(question.type),
    );

export const getHasRequiredWaiverQuestions = (state: CheckoutState) => {
    const allQuestions = [
        ...getQuestionsForAttendees(state).flatMap(({ survey }) => survey),
        ...getQuestionsForBuyer(state),
    ];
    return allQuestions.some((question) => {
        return (
            isWaiverQuestion(question.type) &&
            isRequiredQuestion(question, allQuestions)
        );
    });
};
